<template>
    <div>
        <div class="login-bg-info">
            PEER Platinum Certified<br/>
            NYU Langone Health<br/>
            New York City, NY
        </div>
        <div class="auth-box-w">
            <div class="login-div" v-loading="loading" element-loading-text="Signing in. Please wait...">
                <div class="logo">
                    <img src="/images/logo.png" alt="PEER"/>
                </div>
                <div v-if="maintenanceShortMessage != ''" class="maintenance-msg" v-html="maintenanceShortMessage"></div>
                <div class="form-section">
                    <form class="login-form">
                        <div v-if="loginError != ''" class="alert alert-danger">
                            <span>
                                <button type="button"
                                    class="close col-xs-1"
                                    aria-label="Close"
                                    @click="loginError = ''">
                                        <span aria-hidden="true">&times;</span>
                                </button>
                            </span>
                            <span class="alertmessage"><span>{{ loginError }}</span></span>
                        </div>
                        <div v-else-if="successMessage != ''" class="alert alert-success">
                            <span>
                                <button type="button"
                                    class="close col-xs-1"
                                    aria-label="Close"
                                    @click="successMessage = ''">
                                        <span aria-hidden="true">&times;</span>
                                </button>
                            </span>
                            <span class="alertmessage"><span>{{ successMessage }}</span></span>
                        </div>
                        <div class="form-group" style="font-size:14px;margin-top:5px;">
                            <p>Certify your PEER project in PEER Online.</p>
                            <p>We now have a single sign on for all USGBC and GBCI websites.</p>
                        </div>
                        <div class="form-group" style="margin-bottom:0px;text-align:center;">
                            <a href="javascript:void(0)" @click.prevent="doAuthRedirect('login')">Proceed to sign on</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isBgLoaded: false,
            loading: false,
            statusCheck: false,
            maintenanceShortMessage: '',
            successMessage: '',
            loginError: '',
            redirectTo: null
        }
    },
    
    created() {
        if(this.$route.query.forceEnv)
            this.peer.user.changeEnv(this.$route.query.forceEnv)
        
        this.peer.common.maintenanceSettings(
            (this.$route.query.__allowMe && this.$route.query.__allowMe === '1')
        ).then((r) => {
            if(r.maintenance === 1)
                this.maintenanceShortMessage = r.message.short
            else if(r.maintenance === 2) {
                this.$router.push({
                    name: 'maintenance'
                })
            }
        })
        
        if(this.$route.query.successMessage)
            this.successMessage = this.$route.query.successMessage
        
        this.$bus.$on('oAuthClientReady', () => {
            platformApi.onStatusCheck(() => {
                this.statusCheck = true
            })
            
            platformApi.onRedirect((r) => {
                this.redirectTo = r.url
                this.statusCheck = false
            })
            
            platformApi.onError((r) => {
                this.loginError = r.code+': '+r.message
                this.statusCheck = false
            })
            
            platformApi.onLogged((r) => {
                this.statusCheck = false
                this.setUserInfo(r)
            })
            
            platformApi.onTokenChecked((r) => {
                this.statusCheck = false
                this.setUserInfo(r)
            })
            
            platformApi.onExternalLogout(() => {
                this.statusCheck = true
                platformApi._oAuthClientRequest('/status?sdkVersion=v1&accessMode=ajax&callerId='+platformApi.callerId+'&deviceId='+platformApi.deviceId+'&noSilent=0&noAuthUrl=0&redirectUrl='+encodeURIComponent(platformApi.redirectUrl))
            })
        })
    },
    
    mounted() {
        if(this.peer.is.ie()) {
            this.peer.misc.blockScreenTransparent('.login-form', 'Microsoft Internet Explorer browser is not supported, please use other browsers like Chrome, Firefox.')
            return false
        }
        
        this.toggleBodyClass('addClass', 'login-page')
    },
    
    beforeDestroy() {
        this.$bus.$off('oAuthClientReady')
    },
    
    destroyed() {
        this.toggleBodyClass('removeClass', 'login-page')
    },
    
    methods: {
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body
            
            if(addRemoveClass === 'addClass') {
                el.classList.add(className)
                this.peer.$.backstretch('/images/theme/bg-image-min.jpg')
                this.peer.$(window).on('backstretch.after', () => {
                    setTimeout(() => {
                        this.isBgLoaded = true
                    }, 500)
                })
            }
            else {
                el.classList.remove(className)
                this.peer.$.backstretch('destroy')
            }
        },
        
        setUserInfo(data) {
            this.loading = true
            this.peer.user.setInfo(data).always((r) => {
                this.loading = false
            }).fail((r) => {
                let err = this.$api.getError(r)
                
                if(this.peer.user.isTokenInvalid(r.data))
                    err = 'Invalid token or token expired.'
                
                this.loginError = err
            })
        },
        
        doAuthRedirect(screen) {
            if(this.redirectTo)
                document.location.href = this.redirectTo+'?screen='+screen
        }
    }
}
</script>

<style scoped></style>
